import { useMutation } from "@tanstack/react-query";
import { fetchPartnerApply } from "@features/auth/api/partnerApi";

export const usePartnerApply = (iCafeId: string) => {
  return useMutation({
    mutationFn: () => fetchPartnerApply(iCafeId),
  });
};
